<template>
  <section class="ue-color-picker">
    <div class="position-relative">
      <input
        class="form-control w-100"
        type="text"
        placeholder="Enter a color"
        @paste="handlePaste"
        @change="colorChanged"
        v-model="localValue"
      />
      <b-form-input
        type="color"
        v-model="localValue"
        @update:modelValue="$emit('update:modelValue', $event)"
        @change="colorChanged"
        @input="$emit('input', $event)"
        class="position-absolute bg-transparent border-0"
      />
    </div>
  </section>
</template>
<script setup lang="ts">
import { ref, watch } from 'vue'
import { ColorTranslator } from 'colortranslator'

const DEFAULT_COLOR = '#ffffff'

const props = defineProps<{
  value?: string
}>()

const emit = defineEmits(['update:modelValue', 'change', 'input'])

watch(
  () => props.value,
  (newVal: string) => {
    localValue.value = newVal
  },
)

const localValue = ref(props.value)

const colorChanged = (): void => {
  try {
    const color = new ColorTranslator(localValue.value)
    localValue.value = color.HEX.toLocaleLowerCase()
  } catch (error) {
    localValue.value = DEFAULT_COLOR
  }

  emit('change', localValue.value)
}

const handlePaste = (event: ClipboardEvent): void => {
  event.preventDefault()
  const clipboardData = event.clipboardData
  if (!clipboardData) return

  const pastedText = clipboardData.getData('text')

  try {
    const color = new ColorTranslator(pastedText)
    localValue.value = color.HEX.toLocaleLowerCase()
  } catch (error) {
    localValue.value = DEFAULT_COLOR
  }

  emit('change', localValue.value)
}
</script>

<style lang="sass" scoped>
.ue-color-picker
  input[type='text']
    height: 40px

  input[type='color']
    top: 1px
    right: 1px
    width: 38px // very specific, but needed b/c color swatch is not easy to style
    cursor: pointer

    &:focus
      outline: none
      box-shadow: none

    &::-webkit-color-swatch
      border-radius: 0.25rem
</style>
